import classNames from 'classnames';
import { getBackgroundClassFromSubTheme } from './constants';
import { pageApi, themeApi } from '../../../api/service';
import { BackgroundThemeRevision } from 'referral-types';
import { useMediaOverride } from '../../../hooks/useMediaOverride';

export const PresetMediaBackground = (props: {
  themeRevision?: Partial<BackgroundThemeRevision>;
  themeId?: string;
}) => {
  const { themeRevision, themeId } = props;
  const subTheme = themeRevision?.subTheme;
  const backgroundClass = getBackgroundClassFromSubTheme(subTheme);

  const { style, videoSrc } = useMediaOverride({
    themeId,
    themeRevision,
    getOverrideSrc: pageApi.getBackgroundImageSrc,
    getPresetSrc: themeApi.getBackgroundThemePresetSrc,
  });

  return (
    <div className={classNames(backgroundClass, 'relative -z-10 h-full w-full')}>
      {videoSrc ? (
        <video className="h-full w-full object-cover" src={videoSrc} autoPlay loop muted playsInline />
      ) : (
        <div id="preset-media-background" className="h-full w-full" style={style} />
      )}
    </div>
  );
};
